import React, { useEffect, useState } from "react";
import axios from "axios";
import Dump from "../components/dump.tsx";
import { getEnv } from "../helpers/env.ts";
import type { ProductData } from "../rest.interface.ts";
import Product from "./product";
import Filter from "./filter";
import Pagination, { getTotalPages } from '../components/pagination';
import { objectClone, objectFlip } from '../helpers/utils';
import Range from '../components/range';
import { getTrackBackground } from "react-range";
import Spinner from "../components/spinner";

export default function ProductListing(props) {
	const perPage = 100;

	const [currentPage, setCurrentPage] = useState(0);
	const [filters, setFilters] = useState({});

	const [width, setWidth] = useState({
		min: null,
		max: null,
		selectedMin: null,
		selectedMax: null
	});
	const [height, setHeight] = useState({
		min: null,
		max: null,
		selectedMin: null,
		selectedMax: null
	});

	const [products, setProducts] = useState(null);
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [shownProducts, setShownProducts] = useState(null);

	const [locations, setLocations] = useState(null);
	const [types, setTypes] = useState(null);

	function onWidthSliderChange(range) {
		setWidth({
			...width,
			selectedMin: range[0],
			selectedMax: range[1],
		});
	}

	function onHeightSliderChange(range) {
		setHeight({
			...height,
			selectedMin: range[0],
			selectedMax: range[1],
		});
	}

	function onPageChange(page) {
		setCurrentPage(page);
	}

	function onCheckboxChange(e, property: string, value: any) {
		console.log(property, value);

		if (e.target.checked === true) {
			addFilter(property, value);
		} else {
			removeFilter(property, value);
		}
	}

	function addFilter(property, value) {
		let newFilters = objectClone(filters);

		if (newFilters.hasOwnProperty(property) === false) {
			newFilters[property] = [value];
		} else if (!newFilters[property].includes(value)) {
			newFilters[property].push(value);
		}

		setFilters(newFilters);
	}

	function removeFilter(property: string, value: any) {
		let newFilters = objectClone(filters);

		if (newFilters.hasOwnProperty(property) === true) {
			let index = newFilters[property].indexOf(value);

			if (index > -1) {
				newFilters[property].splice(index, 1);
			}
		}

		if (newFilters[property].length === 0) {
			delete newFilters[property];
		}

		setFilters(newFilters);
	}

	function applyPagination() {
		if (products === null) {
			return null;
		}

		let productsToReturn = [];
		let productsCopy = [...filteredProducts];

		if (currentPage) {
			let offset = ((currentPage - 1) * perPage);
			productsToReturn = productsCopy.splice(offset, perPage);
		} else {
			productsToReturn = productsCopy;
		}

		//console.log('perpage: ' + perpage);
		//console.log('currentPage: ' + currentPage);
		//console.log('page: ' + page);
		//console.log('offset: ' + offset);

		return productsToReturn;
	}

	function applyFilters() {
		let productsToReturn = [];

		products && products.map(function(product: ProductData) {
			let isShown = true;
			if (product.width < width.selectedMin || product.width > width.selectedMax) {
				isShown = false;
			}

			if (product.height < height.selectedMin || product.height > height.selectedMax) {
				isShown = false;
			}

			// console.log(isShown);

			for (let filterId in filters) {
				console.log(filterId);

				let found = false;

				for (let z = 0; z < filters[filterId].length; z++) {
					let filterValue = filters[filterId][z];

					if (typeof product[filterId] !== 'undefined') {
						if (product[filterId] == filterValue) {
							found = true;
						}
					}
				}

				if (found === false) {
					isShown = false;
				}
				//console.log(product.attributes[filterId].indexOf(this.state.filters[filterId]));
			}

			if (isShown === true) {
				productsToReturn.push(product);
			}
		})

		return productsToReturn;
	}

	useEffect(() => {
		setFilteredProducts(applyFilters())
		setCurrentPage(1);
	}, [products, width, height, filters]);

	useEffect(() => {
		setShownProducts(applyPagination());
	}, [filteredProducts, currentPage]);

	useEffect(() => {
		let id = props.id;
		//console.log("loading");

		function getAll() {
			async function getProducts() {
				return axios.get(getEnv('PUBLIC_API_HOST') + '/api/products/' + id)
					.then(async (response) => {
						return response.data;
					}).catch(function (error) {
						if (error.response && error.config) {
							console.log('Axios ' + error.response.status + ':', error.config.url, id)
						}
					});
			}

			async function getLocations() {
				return axios.get(getEnv('PUBLIC_API_HOST') + '/api/locationType')
					.then(async (response) => {
						return response.data;
					}).catch(function (error) {
						if (error.response && error.config) {
							console.log('Axios ' + error.response.status + ':', error.config.url)
						}
					});
			}

			async function getTypes() {
				return axios.get(getEnv('PUBLIC_API_HOST') + '/api/productType')
					.then(async (response) => {
						return response.data;
					}).catch(function (error) {
						if (error.response && error.config) {
							console.log('Axios ' + error.response.status + ':', error.config.url)
						}
					});
			}

			return Promise.all([getProducts(), getLocations(), getTypes()]);
		}

		getAll().then(([productsLoaded, locationsLoaded, typesLoaded]) => {
			let minWidth = Infinity;
			let maxWidth = 0;

			let minHeight = Infinity;
			let maxHeight = 0;

			for (let i = 0; i < productsLoaded.length; i++) {
				let product = productsLoaded[i];

				if (product.width < minWidth) { minWidth = product.width; }
				if (product.width > maxWidth) { maxWidth = product.width; }

				if (product.height < minHeight) { minHeight = product.height; }
				if (product.height > maxHeight) { maxHeight = product.height; }
			}

			if (minWidth === Infinity) {
				minWidth = 0;
				maxWidth = Infinity;
			}

			if (minHeight === Infinity) {
				minHeight = 0;
				maxHeight = Infinity;
			}

			setProducts(productsLoaded);

			setWidth({
				min: Math.floor(minWidth),
				max: Math.ceil(maxWidth),
				selectedMin: Math.floor(minWidth),
				selectedMax: Math.ceil(maxWidth)
			});

			setHeight({
				min: Math.floor(minHeight),
				max: Math.ceil(maxHeight),
				selectedMin: Math.floor(minHeight),
				selectedMax: Math.ceil(maxHeight)
			});

			setLocations(locationsLoaded);
			setTypes(typesLoaded);
		});
	}, []);

	function renderRangeWidth() {
		if (width.min !== null && width.max !== null && width.max !== Infinity && width.min !== width.max) {
			const colorMain = '#263749';
			return (<>
				<p className="mb-4">Size - width (cm)</p>
				<div className="px-4 pb-4">
					<Range
						colorMain = {colorMain}
						values={[width.selectedMin, width.selectedMax]}
						step={1}
						min={width.min}
						max={width.max}
						onChange={onWidthSliderChange}
						background={getTrackBackground({
							values: [width.selectedMin, width.selectedMax],
							colors: ['#999', colorMain, '#999'],
							min: width.min,
							max: width.max
						})}
					/>
				</div>
			</>);
		}

		return null;
	}

	function renderRangeHeight() {
		if (height.min !== null && height.max !== null && height.max !== Infinity && height.min !== height.max) {
			const colorMain = '#263749';
			return (<>
				<p className="mb-4">Size - height (cm)</p>
				<div className="px-4 pb-4">
					<Range
						colorMain = {colorMain}
						values={[height.selectedMin, height.selectedMax]}
						step={1}
						min={height.min}
						max={height.max}
						onChange={onHeightSliderChange}
						background={getTrackBackground({
							values: [height.selectedMin, height.selectedMax],
							colors: ['#999', colorMain, '#999'],
							min: height.min,
							max: height.max
						})}
					/>
				</div>
			</>);
		}

		return null;
	}

	return (<>
		<div className="flex flex-wrap text-left w-full items-stretch px-0 md:px-20 xl:px-40 max-w-screen-2xl">

			{/*<Dump value={props}/>*/}

			<div className="filters w-full lg:w-1/4 px-8">
				<h4 className="uppercase my-12">{props.name}</h4>

				{props.showLocation && <Filter
					name="Location"
					property="locationId"
					values={locations ? objectFlip(locations) : {}}
					selectedFilters={filters['locationId']}
					onCheckboxChange={onCheckboxChange}
				/>}

				{props.showType && <Filter
					name="Medium & Material"
					property="typeId"
					values={locations ? objectFlip(types) : {}}
					selectedFilters={filters['typeId']}
					onCheckboxChange={onCheckboxChange}
				/>}

				{props.showSize && <>
					<div className="filter">{renderRangeWidth()}</div>
					<div className="filter">{renderRangeHeight()}</div>
				</>}

				{props.showAvailability && <Filter
					name="Available"
					property="available"
					values={{"": true}}
					selectedFilters={filters['available']}
					onCheckboxChange={onCheckboxChange}
				/>}

				{props.showLatest && <Filter
					name="Latest Paintings"
					property="latest"
					values={{"": true}}
					selectedFilters={filters['latest']}
					onCheckboxChange={onCheckboxChange}
				/>}

				<p className="block mt-8 text-sm text-grey-500">Please click on thumbnails</p>

				<Dump value={filters}/>
			</div>

			<div className="w-full lg:w-3/4 md:px-8">
				<div className="bg-grey-100 py-8 px-12 h-full">
					<article className="flex flex-wrap -mx-3">
						{shownProducts && shownProducts.map(product => {
							return (<Product value={product} key={product.id}/>);
						})}

						{(products !== null && shownProducts !== null && shownProducts.length === 0) &&
							<div className="text-center grow align-center text-2xl my-24">No artworks found</div>}

						{products === null && <div className="text-center grow align-center my-24"><Spinner/></div>}
					</article>

					{/*<Pagination*/}
					{/*	setCurrentPage={onPageChange}*/}
					{/*	currentPage={currentPage}*/}
					{/*	totalPages={getTotalPages(filteredProducts.length, perPage)}*/}
					{/*/>*/}
				</div>
			</div>
		</div>
	</>);
}
